<div><h1>New Location</h1><LoaderOverlay :loading="loading"><LocationForm></LocationForm></LoaderOverlay></div>